<script setup lang="ts">
const title = ref('JasaPembayaran');
const { mode, widthLabel, load, isFramed } = useDevicePreview();
const { t, load: loadLocale, locale } = useI18n();

useHead({
  meta: [{ content: title }],
  htmlAttrs: {
    lang: () => (locale.value === 'en' ? 'en' : 'id'),
  },
  link: [
    { rel: 'icon', type: 'image/png', href: '/images/logos/iconadr.png' },
    { rel: 'apple-touch-icon', href: '/images/logos/iconadr.png' },
  ],
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} - JasaPembayaran` : 'JasaPembayaran';
  },
});

onMounted(() => {
  loadLocale();
  load();
});

const badgeText = computed(() => {
  if (mode.value === 'tablet') return `${t('device.tablet')} · ${widthLabel.value}`;
  if (mode.value === 'hp') return `${t('device.hp')} · ${widthLabel.value}`;
  return '';
});

const studioClass = computed(() => [
  'jgi-device-studio',
  `jgi-device-studio--${mode.value}`,
  { 'jgi-device-studio--framed': isFramed.value },
]);

/** Inline style cadangan — px dari viewport nyata */
const stageStyle = computed(() => {
  if (!isFramed.value) return undefined;
  const w = mode.value === 'hp' ? 390 : 768;
  return {
    width: `min(${w}px, calc(100vw - 24px))`,
    height: 'calc(100vh - 80px)',
    minHeight: '560px',
    maxHeight: 'calc(100vh - 80px)',
    marginLeft: 'auto',
    marginRight: 'auto',
  };
});

const appStyle = computed(() => {
  if (!isFramed.value) return undefined;
  return {
    width: '100%',
    height: 'calc(100vh - 80px)',
    minHeight: '560px',
    maxHeight: 'calc(100vh - 80px)',
    background: '#d7e8e4',
    display: 'flex',
    flexDirection: 'column' as const,
    overflow: 'hidden',
  };
});
</script>

<template>
  <div :class="studioClass">
    <v-locale-provider>
      <div
        class="jgi-device-stage"
        :class="{ 'jgi-device-stage--framed': isFramed }"
        :style="stageStyle"
      >
        <v-app class="jgi-device-app" :style="appStyle">
          <LayoutFullMain />
          <v-main class="app-main">
            <div class="app-shell hr-layout bg-containerBg">
              <v-container fluid class="page-wrapper bg-background rounded-xl">
                <div class="maxWidth">
                  <LayoutFinanceContextBar />
                  <NuxtPage />
                </div>
              </v-container>
            </div>
          </v-main>
          <ChatTasyaLiveChat />
        </v-app>
        <!-- Host overlay profil — di luar v-app agar flex Vuetify tidak collapse -->
        <div id="jgi-frame-overlays" class="jgi-frame-overlays" />
      </div>
    </v-locale-provider>

    <ClientOnly>
      <div v-if="isFramed" class="jgi-device-badge" aria-live="polite">
        <span class="jgi-device-badge__dot" aria-hidden="true" />
        {{ badgeText }}
        <span class="jgi-device-badge__hint">{{ t('device.previewHint') }}</span>
      </div>
    </ClientOnly>
  </div>
</template>
